/* src/app/components/lead-details/participant-information/lead-application-details/lead-application-details.component.css */
/*# sourceMappingURL=lead-application-details.component-7BU4DI5O.css.map */
